<ng-container *ngIf="currentUser$ | async as currentUser;">

  <ng-container *ngIf="(surveysDetails$ | async) as surveysDetails">

    <div [fxFlex]="surveysDetails?.temp?.length > 0 ? 50 : 'auto'" class="h-100-p w-100-p">

      <div class="grid-container">

        <dx-data-grid
          #responseGrid
          *ngIf="surveysDetails.responses"

          [hoverStateEnabled]="true"
          keyExpr="surveyResponseId"

          [dataSource]="surveysDetails.responses"
          [height]="'100%'"
          [width]="'100%'"

          [columnAutoWidth]="true"

          [allowColumnReordering]="true"
          [allowColumnResizing]="true"

          [showColumnLines]="false"
          [showRowLines]="false"
          [showBorders]="true"
          [rowAlternationEnabled]="false"

        >
          <dxo-selection mode="single"></dxo-selection>
          <dxo-search-panel [visible]="true" [width]="'70%'" [placeholder]="'Rechercher...' | translate"></dxo-search-panel>
          <dxo-filter-panel [visible]="true"></dxo-filter-panel>
          <dxo-group-panel [visible]="false"></dxo-group-panel>

          <dxo-scrolling mode="virtual"></dxo-scrolling>

        </dx-data-grid>

      </div>

    </div>


    <div fxFlex="50" class="h-100-p w-100-p" *ngIf="surveysDetails.temp.length > 0">

      <div class="grid-container">

        <dx-data-grid
          #tempGrid
          *ngIf="surveysDetails.temp"

          [hoverStateEnabled]="true"

          [dataSource]="surveysDetails.temp"
          [height]="'100%'"
          [width]="'100%'"

          [columnAutoWidth]="true"

          [allowColumnReordering]="true"
          [allowColumnResizing]="true"

          [showColumnLines]="false"
          [showRowLines]="false"
          [showBorders]="true"
          [rowAlternationEnabled]="false"

          (onRowClick)="selectPartial($event)"

        >
          <dxo-selection mode="single"></dxo-selection>
          <dxo-search-panel [visible]="true" [width]="'70%'" [placeholder]="'Rechercher...' | translate"></dxo-search-panel>
          <dxo-filter-panel [visible]="true"></dxo-filter-panel>
          <dxo-group-panel [visible]="false"></dxo-group-panel>

          <dxo-scrolling mode="virtual"></dxo-scrolling>

        </dx-data-grid>

      </div>

    </div>

  </ng-container>

  <dx-popup

    *ngIf="displayPartialDetail"

    [width]="'80%'"
    [height]="'80%'"

    [showTitle]="true"
    title="Partial informations"

    [dragEnabled]="true"

    [resizeEnabled]="true"

    [closeOnOutsideClick]="true"
    [(visible)]="displayPartialDetail"

    (onHidden)="hidePopOver()"

  >

    <div fxLayout="column" *dxTemplate="let data of 'content'">

      <div fxFlex fxLayout="column" class="p-8">

        <div fxFlex fxLayout fxLayoutAlign="start center">

          <div fxFlex="20"><h2>Created: {{currentPartial.created | date: 'short'}}</h2></div>

          <div fxFlex>
            <ng-container *ngIf="allreadyRepliedId.includes(''+currentPartial.surveyId)">
              <div class="message-box warning">
                [Réponse complete reçue]
              </div>
              </ng-container>
            Direct link:
            <app-url-placeholder class="p-5" [url]="getUrl(currentUser.jwtToken, currentPartial.surveyId, currentPartial._id)"></app-url-placeholder>
            <pre>Temp _id: {{currentPartial._id}}</pre>
          </div>

        </div>

        <div fxFlex fxLayout fxLayoutAlign="start center">

          <div fxFlex="20">
<!--            <btn-display-survey [surveyId]="currentPartial.surveyId"></btn-display-survey>-->
            SurveyId:{{currentPartial.surveyId}}
            Tous les partial du questionnaire :
            <app-partials-for-surveys [surveyId]="currentPartial.surveyId"></app-partials-for-surveys>
          </div>
          <div fxFlex>userId: {{currentPartial.userId}}</div>

        </div>

      </div>

      <div fxFlex="100" style="overflow: auto">
        <pre>{{currentPartial | json}}</pre>
      </div>

    </div>

  </dx-popup>

</ng-container>
